import {
  Box,
  Container,
  Stack,
  Typography,
  useTheme,
  SxProps,
  Theme,
} from '@mui/material';
import { useWindowWidth } from '~/hooks/useSize';

const Layout = ({
  children,
  title,
  action,
  sx,
}: {
  children: React.ReactNode;
  title: React.ReactNode;
  action: React.ReactNode;
  sx?: SxProps<Theme>;
}) => {
  const theme = useTheme();
  const { width } = useWindowWidth();

  return (
    <Box
      style={{
        minHeight: width > 1280 ? '100vh' : 'calc(100vh - 30px)',
        backgroundColor: theme.background.pageBg,
      }}
      className='customized-scrollbar'
      sx={sx}
    >
      <Container
        sx={{
          'width': '100%',
          'maxWidth': 'unset !important',
          'padding': 2,
          '@media screen and (min-width: 600px)': {
            padding: '16px 24px',
          },
        }}
      >
        <Stack spacing={2}>
          <Box sx={{ display: 'flex' }}>
            {typeof title === 'string' ? (
              <Typography
                sx={{ ...theme.getTypoProperties(20) }}
                fontWeight='fontWeightBold'
                color={theme.foreground.black}
              >
                {title}
              </Typography>
            ) : (
              title
            )}
            {action && <Box ml='auto'>{action}</Box>}
          </Box>
          {children}
        </Stack>
      </Container>
    </Box>
  );
};

export default Layout;
